import { render, staticRenderFns } from "./RsaPazienteRiepilogoOperatoriEquipeListModalComponent.vue?vue&type=template&id=32ebfe28"
import script from "./RsaPazienteRiepilogoOperatoriEquipeListModalComponent.vue?vue&type=script&lang=js"
export * from "./RsaPazienteRiepilogoOperatoriEquipeListModalComponent.vue?vue&type=script&lang=js"
import style0 from "./RsaPazienteRiepilogoOperatoriEquipeListModalComponent.vue?vue&type=style&index=0&id=32ebfe28&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports